import Swiper, { Autoplay, Pagination } from 'swiper';
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CSSRulePlugin } from "gsap/CSSRulePlugin";
import DrawSVGPlugin from '../../plugins/gsap/DrawSVGPlugin';
import ClfFeedSlider from "./ClfFeedSlider";

gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger, CSSRulePlugin);

class VerticalClf {
    constructor() {
        this.initSlider()
        this.handwritingAnimation();
        this.initMissionsAnimation();
    }

    initSlider_webgl() {
        const el = document.querySelector('.clf-hero-slider');

        if (el) {
            const slides = el.querySelectorAll('.swiper-slide');
            const imageLoadPromises = [];
            const elWidth = el.offsetWidth;
            const elHeight = el.offsetHeight;

            slides.forEach((slide, index) => {
                const background = slide.getAttribute('data-layer-background');

                if (background) {
                    const imageBackground = new Image();
                    imageBackground.src = background;

                    const imageLoadPromise = new Promise((resolve) => {
                        imageBackground.onload = () => {
                            const canvas = document.createElement('canvas');
                            const context = canvas.getContext('2d');

                            canvas.width = elWidth;
                            canvas.height = elHeight;

                            // Draw background image with object-fit: cover effect
                            const aspectRatio = Math.max(elWidth / imageBackground.width, elHeight / imageBackground.height);
                            const imgWidth = imageBackground.width * aspectRatio;
                            const imgHeight = imageBackground.height * aspectRatio;
                            const posX = (elWidth - imgWidth) / 2;
                            const posY = (elHeight - imgHeight) / 2;

                            context.drawImage(imageBackground, posX, posY, imgWidth, imgHeight);
                            const finalImage = document.createElement('img');
                            finalImage.src = canvas.toDataURL();
                            finalImage.className = 'swiper-gl-image';
                            const imageContainer = slide.querySelector('.gl-slider-image');
                            imageContainer.appendChild(finalImage);

                            resolve();
                        };

                        imageBackground.onerror = () => {
                            console.error(`Background image of slide ${index + 1} failed to load`);
                            resolve();
                        };
                    });

                    imageLoadPromises.push(imageLoadPromise);
                }
            });

            Promise.all(imageLoadPromises).then(() => {
                const swiperClfHero = new Swiper(el, {
                    modules: [SwiperGL, Pagination, Autoplay],
                    speed: 1300,
                    slidesPerView: 1,
                    loop: true,
                    autoplay: {
                        enabled: true,
                        delay: 2500,
                        disableOnInteraction: false,
                    },
                    effect: 'gl',
                    gl: {
                        shader: 'wind',
                    },
                });
            });
        }

    }

    initSlider() {
        const el = document.querySelector('.clf-hero-slider');
        if(!el) return;

        const swiperClfHero = new Swiper(el, {
            modules: [Pagination, Autoplay],
            speed: 1300,
            slidesPerView: 1,
            loop: true,
            autoplay: {
                enabled: true,
                delay: 2500,
                disableOnInteraction: false,
            },
            effect: 'fade',
        });

        const feedSliderEl = document.querySelector('.clf-feed-slider');
        if(feedSliderEl) {
            new ClfFeedSlider('.clf-feed-slider');
        }
    }

    handwritingAnimation() {
        if(document.querySelector('#clf-handwriting')) {
            gsap.timeline(
                {
                delay:0.5,
                defaults: {
                    duration: 0.5,
                    ease:'circ.out',
                }
            })
            .fromTo('#mask-dummy', {drawSVG: '0% 0%'}, {drawSVG: true})
            .fromTo('#mask-c', {drawSVG: '0% 0%'}, {drawSVG: true, ease: "none"}, '-=0.1')
            .fromTo('#mask-l', {drawSVG: '100% 100%'}, {drawSVG: true, ease: "none"}, '-=0.1')
            .add('add', '-=0.1')
            .fromTo('#mask-f-1', {drawSVG: '0% 0%'}, {drawSVG: true, ease: "none"}, 'add')
            .fromTo('#mask-f-2', {drawSVG: '0% 0%'}, {drawSVG: true, ease: "none"},'add')
            .fromTo('#mask-f-3', {drawSVG: '0% 0%'}, {drawSVG: true, ease: "none"},'-=0.3')
        }

        const titleHandwritingEl = document.querySelectorAll('[data-path-animation]');
        if(titleHandwritingEl.length) {
            const speed = 0.2;
            gsap.set(titleHandwritingEl, {drawSVG: '0%'}); //Set the initial state of the path
            const animate = (index) => {
                if (index >= titleHandwritingEl.length) return;
                gsap.to(titleHandwritingEl[index], {drawSVG: true, duration: speed, ease: 'none',
                    onStart : () => {
                        setTimeout(() => {
                            animate(index + 1);
                        }, 100);
                    }}); //Animate path
            };
            animate(0);
        }

    }

    initMissionsAnimation() {
        let tl1 = gsap.timeline();

        const yStart = 50;
        const duration = 0.75;
        const autoAlphaStart = 0;
        const staggerDelay = 0.5;
        const ease = 'power2.Out';

        const missionEls = document.querySelectorAll('.clf-missions .mission-col');

        missionEls.forEach((missionEl, index) => {
            missionEl.style.visibility = 'visible';

            tl1.from(missionEl.querySelector('.eyebrow'), {duration, y: yStart, autoAlpha: autoAlphaStart, ease}, index === 0 ? 0 : `-=${staggerDelay}`)
                .from(missionEl.querySelector('.clf-h3'), {duration, y: yStart, autoAlpha: autoAlphaStart, ease}, `-=${staggerDelay}`)
                .from(missionEl.querySelector('.btn-wrap'), {duration, y: yStart, autoAlpha: autoAlphaStart, ease}, `-=${duration}`);

            const underlineEls = missionEl.querySelectorAll('.clf-underline');
            underlineEls.forEach(underlineEl => {
                tl1.add(() => {
                    underlineEl.classList.add('clf-underline-draw');
                }, `-=${duration}`);
            });
        });

        ScrollTrigger.create({
            animation: tl1,
            trigger: ".clf-missions .container",
            start: "top bottom",
            once: true
        });
    }
}

export default VerticalClf
